import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import * as AuthAPI from '../services/authAPI';
import AuthContext from '../context/AuthContext';
import Field from '../components/Field';
import './LoginPage.css';

export default function LoginPage() {

    const { setIsAuthenticated } = useContext(AuthContext);
    const navigate = useNavigate();

    const [credentials, setCredentials] = useState({
            username: "",
            password: ""
    });

    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleChange = ({ currentTarget }) => {
            const { value, name } = currentTarget;
            setCredentials({...credentials, [name]: value});
    };

    const handleSubmit = async event => {
        event.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
            await AuthAPI.authenticate(credentials);
            setError("");
            setIsAuthenticated(true);
            navigate("/", { replace: true });
        } catch (error) {
            setCredentials({username: "", password: ""});
            if (error.status === 401) {
                setError("E-mail ou mot de passe incorrect");
            } else {
                setError("Service indisponible");
            }
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <section className="login-section vh-100">
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                    <div className="card shadow-2-strong">
                        <form className="card-body p-5 text-center" onSubmit={handleSubmit}>
                            <h3 className="mb-2">Nemo</h3>
                            <p className="text-muted mb-5">Connectez-vous à votre compte</p>
                                <Field
                                    name="username"
                                    label="Adresse electronique"
                                    value={credentials.username}
                                    onChange={handleChange}
                                    type="email"
                                    error={error}
                                />
                                <Field
                                    name="password"
                                    label="Mot de passe"
                                    value={credentials.password}
                                    onChange={handleChange}
                                    type="password"
                                    error={error}
                                />
                                {error && (
                                    <div className="login-error">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.436-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                        </svg>
                                        <span>{error}</span>
                                    </div>
                                )}
                                <div className="row mb-4">
                                    <a href="#!" onClick={e => { e.preventDefault(); navigate('/forgot-password'); }}>Mot de passe oublie ?</a>
                                </div>
                                <div className="row">
                                    <button type="submit" disabled={submitting} className="col-md btn btn-primary">
                                        {submitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Connexion...
                                            </>
                                        ) : "Connexion"}
                                    </button>
                                </div>
                        </form>
                    </div>
                </div>
                </div>
            </div>
        </section>
    )
}
